import Phone from './index'
export default [
  {
    path: '/change/phone',
    name: 'safe-change-phone',
    component: Phone
  },
]
